import styled from "styled-components";
import {Link} from "react-router-dom";

export const Container = styled.section`
    width: 100%;
    background-color: #36a2d8;
    margin-top: auto;
`
export const Wrap = styled.div`
    max-width: 1140px;
    margin: 0 auto;
    padding: 50px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    transition: 0.2s;
    @media screen and (max-width: 1140px){
        padding: 50px 20px;
    }
    @media screen and (max-width: 767px){
        flex-direction: column;
    }
`
export const Title = styled.h3`
    font-size: 20px;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        text-align: center;
    }
`
const baseBtnStyles = `
    text-transform: uppercase;
    background-color: #f56a5f;
    padding: 20px 28px;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 2px;
    color: #ffffff;
    font-weight: 700;
    transition: 0.2s;
    text-decoration: none;
    display: inline-block;
    &:hover {
        background-color: #252525 ;
        transition: 0.2s;
    }
    @media screen and (max-width: 767px){
        text-align: center;
    }
`;

export const Btn = styled(Link)`
    ${baseBtnStyles}
`;

export const BtnLink = styled.a`
    ${baseBtnStyles}
`;